<app-dialog
  #dialog
  [key]="'meeting-transcript'"
  [action]="'meeting-transcript'"
  [headerTheme]="'simple'"
  [title]="'Transcrição da reunião'"
  [maxWidth]="'760px'"
  [showMaximizeButton]="true">
  <div class="meeting-transcript">
    @if (ligacao(); as meeting) {
      <p class="meeting-transcript__title">
        {{ meeting.title }} · {{ meeting.scheduledStartAt | vaultDateTime }}
      </p>
    }

    @if (carregando()) {
      <div class="meeting-transcript__state">
        <app-cog-loading-spinner [size]="56" />
        <span>Buscando a transcrição...</span>
      </div>
    } @else if (erro()) {
      <div class="meeting-transcript__state meeting-transcript__state--error" role="alert">
        <i class="pi pi-file" aria-hidden="true"></i>
        <span>{{ erro() }}</span>
      </div>
    } @else if (!trechos().length) {
      <div class="meeting-transcript__state">
        <i class="pi pi-file" aria-hidden="true"></i>
        <span>A transcrição desta reunião está vazia.</span>
      </div>
    } @else {
      <ol class="meeting-transcript__list">
        @for (trecho of trechos(); track $index; let i = $index) {
          <li
            class="meeting-transcript__item"
            [class.meeting-transcript__item--cont]="mesmoFalanteQueOAnterior(i)">
            @if (!mesmoFalanteQueOAnterior(i)) {
              <span class="meeting-transcript__speaker">{{
                trecho.speaker || 'Falante não identificado'
              }}</span>
            }
            <div class="meeting-transcript__line">
              <span class="meeting-transcript__time">{{ tempo(trecho.startSeconds) }}</span>
              <p class="meeting-transcript__text">{{ trecho.text }}</p>
            </div>
          </li>
        }
      </ol>
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Fechar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
